import { useParams } from 'react-router-dom';
import FicheLocataire from './FicheLocataire';

export default function FicheLocataireAuto() {
  const { id } = useParams();
  return <FicheLocataire locataireId={id} />;
}